export default {
	seo_meta_title_leaguepass: 'NBA | NBA Video ve Özetler',
	seo_meta_desc_leaguepass: 'NBA Video, NBA video ve özetler özelliklerine de sahip',
	seo_meta_keywords_leaguepass: 'NBA Videoları, NBA Özetler, Basketbol Videoları, en güzel hareketler, smaçlar, yayınlar',
	seo_meta_title_featured: 'NBA | Öne çıkan',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Canlı',
	seo_meta_desc_nbatv: 'NBA TV Canlı ile 24 saat boyunca, her hafta canlı ve arşiv maçlara ulaşabildiğiniz NBA TV yayını, Stüdyo programları ve analizler elinizin altında',
	seo_meta_keywords_nbatv: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',
	seo_meta_title_classicgames: 'NBA | Klasik Maçlar',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Video Listesi',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | NBA TV Programları',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA Ana Sayfa',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Kanallar',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Kanal',
	seo_meta_pre_title_categories: 'NBA | Kategoriler',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Kategori',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Video',
	seo_meta_pre_title_event: 'NBA | Etkinlik',
	seo_meta_title_events: 'NBA | Etkinlikler',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Etkinlikler: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Arama',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Sayfa Bulunamadı',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA Oyunu:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA Video ve Özetler',
	seo_meta_desc_video: 'NBA Video, NBA video ve özetler özelliklerine de sahip',
	seo_meta_keywords_video: 'NBA Videoları, NBA Özetler, Basketbol Videoları, en güzel hareketler, smaçlar, yayınlar',
	seo_meta_title_channel: 'NBA | NBA TV Canlı',
	seo_meta_desc_channel: 'NBA TV Canlı ile 24 saat boyunca, her hafta canlı ve arşiv maçlara ulaşabildiğiniz NBA TV yayını, Stüdyo programları ve analizler elinizin altında',
	seo_meta_keywords_channel: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',
	seo_meta_title_tvguide: 'NBA | NBA TV Yayın Programı',
	seo_meta_desc_tvguide: 'NBA TV Canlı ile 24 saat boyunca, her hafta canlı ve arşiv maçlara ulaşabildiğiniz NBA TV yayını, Stüdyo programları ve analizler elinizin altında',
	seo_meta_keywords_tvguide: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',
	timezone: 'ET',
	default_feed_error_message: 'Ters giden bir şeyler var, içerik şu anda mevcut değil. Tekrar deneyebilirsiniz.',
	watch_in_app: 'NBA UYGULAMASINDA İZLE',
	no_content: 'İçerik Yok',
	see_more: 'Daha Fazlası',
	now_playing: 'ŞİMDİ OYNANIYOR',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Favori video ekleme üst sınırına ulaştınız. Lütfen daha fazla eklemeden önce bazı favori videolarınızı kaldırın.',
	item_live: 'Canlı:',
	add_favourite_title: 'FAVORİLERE EKLE',
	remove_favourite_title: 'FAVORİLERDEN KALDIR',
	p_channel_live: 'Canlı:',
	p_channel_schedule_title: 'NBA TV Takvimi',
	p_channel_schedule_watch: 'İzle',
	p_channel_schedule_no_date: 'Şu anda mevcut Yayın Tarihi yok.',
	p_channel_live24x7_title: 'NBA TV 7/24',
	p_channel_live24x7_see_full_schedule: 'Tüm Takvimi Gör',
	p_channel_live24x7_up_next: 'sırada',
	p_channel_live24x7_on_demand: 'NBA TV: Seç-İzle',
	p_channel_live24x7_collection: 'Koleksiyon',
	p_channel_live24x7_demand_1_logo_text: 'orijinal programlar',
	p_channel_live24x7_demand_1_show_name: 'NBA TV Programları',
	p_channel_live24x7_demand_1_show_desc: 'Shaqtin\' a Fool, Beyond the Paint, Game Time ve Basketball Stories gibi orijinal NBA TV programları',
	p_channel_live24x7_demand_2_logo_text: 'Klasik Maçlar',
	p_channel_live24x7_demand_2_show_name: 'NBA | Klasik Maçlar',
	p_channel_live24x7_demand_2_show_desc: '2000 yılından günümüze tüm final eşleşmelerini, ligin tarihi anlarını ve efsanevi oyuncuları içeren tam uzunluktaki Klasik Maçları izleyin',
	p_channel_clips_title: 'NBA TV Klipleri',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Program',
	p_nba_tv_shows: 'NBA TV Programları',
	p_nba_tv_no_access_title: '7/24 NBA: Maç analizleri, stüdyo analizleri, orijinal programlar ve daha fazlası ile uzak kalmayın!',
	p_nba_tv_no_access_desc: 'Canlı maçları, programları ve klasik maçları seç-izle ile seyredin.',
	p_nba_tv_no_access_note: 'Karartmalar geçerli olabilir',
	tv_show_item_latest_episode: 'son bölüm',
	tv_show_item_no_latest_episode: 'son bölüm yok',
	see_all: 'Hepsini Gör',
	header_menu_watch: 'İzle',
	header_menu_featured: 'ÖNE ÇIKAN',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Oyuncular',
	videos: 'Videolar',
	teams: 'Takımlar',
	most_searched: 'EN ÇOK ARANANLAR',
	no_result: 'Veri Yok',
	search_filter_type_most_relevant: 'En ilgili',
	search_filter_type_most_viewed: 'En çok görüntülenen',
	search_filter_type_most_recent: 'En yeni',
	search_filter_type_last_30_days: 'Son 30 gün',
	search_filter_type_last_6_months: 'Son 6 ay',
	search_result_label: '\'{keyword}\' için arama sonuçları',
	search_result_info: '{keyword} için tüm sonuçları görüntüleyin',
	search_placeholder: 'Video kütüphanesinde ara',
	load_more: 'Daha fazla yükle...',
	button_subscribe: 'Abone ol',
	button_sign_in: 'Oturum aç',
	p_league_pass_no_access_title: 'Bilgisayarınız, akıllı telefonunuz ve TV\'niz de dahil olmak üzere tüm cihazlarda maçların canlı yayınlarını veya tekrarlarını izleyin!',
	p_league_pass_no_access_desc: 'Aksiyona giriş biletiniz: tüm ligi ya da tuttuğunuz takımı izleyin, tek bir maç seçin veya daha fazla seçeneği inceleyin.',
	p_league_pass_no_access_note: 'Şartlara tabidir',
	category_title: 'Video',
	p_video_playlist_title: 'Oynatma listesi',
	p_no_access_league_pass_title: 'İzlemek için NBA League Pass kilidini açın:',
	p_no_access_league_pass_desc: 'Aksiyona giriş biletiniz: tüm ligi ya da tuttuğunuz takımı izleyin, tek bir maç seçin veya daha fazla seçeneği inceleyin.',
	p_no_access_league_pass_terms: 'Şartlara tabidir',
	p_no_access_league_pass_geo_desc: 'Bulunduğunuz yer nedeniyle bu maçı NBA League Pass ve NBA TV ile görüntüleyemezsiniz. Bu maçların tekrarı, NBA League Pass aboneleri için yayın tarihinden 3 gün sonra hazır olacak. Bölgenizdeki yayınları nereden izleyebileceğiniz konusunda lütfen yerel TV ve radyo yayıncı kuruluşlarınızın programlarına göz atın.',
	p_no_access_league_pass_not_found_desc: 'Üzgünüz, istediğiniz video bulunamadı.',
	p_no_access_event_not_found_desc: 'Üzgünüz, istediğiniz etkinlik bulunamadı.',
	p_no_access_nba_tv_title: 'İzlemek için NBA TV\'nin kilidini açın:',
	p_no_access_nba_tv_desc: 'Canlı maçların yanı sıra programları ve klasik maçları seç-izle ile seyredin.',
	p_no_access_nba_tv_terms: 'Şartlara tabidir',
	p_no_access_nba_tv_geo_desc: 'Bulunduğunuz yer nedeniyle bu maçı NBA League Pass ve NBA TV ile görüntüleyemezsiniz. Bu maçların tekrarı, NBA League Pass aboneleri için yayın tarihinden 3 gün sonra hazır olacak. Bölgenizdeki yayınları nereden izleyebileceğiniz konusunda lütfen yerel TV ve radyo yayıncı kuruluşlarınızın programlarına göz atın.',
	p_no_access_nba_tv_not_found_desc: 'Üzgünüz, istediğiniz kanal bulunamadı.',
	p_no_access_up_next: 'Sırada:',
	p_video_completed_title: 'Oynatma Listesi Tamamlandı',
	p_video_completed_desc: 'Göz atmak için geri gidin veya size özel bir sonraki oynatma listesine bakın',
	p_video_share_to: 'Paylaş:',
	p_video_more_to_watch: 'İzlemek İçin Daha Fazlası:',
	p_event_section_title: 'ETKİNLİK',
	p_event_playlist_title: 'Oynatma listesi',
	p_event_button_watch: 'İzle',
	p_event_button_listen: 'Dinle',
	p_event_button_ticket: 'Bilet',
	notfound: 'Maalesef istediğiniz sayfa bulunamadı.',
	notfound_desc: 'Lütfen hatalar için URL\'yi kontrol edin.<br/> Ayrıca içeriğinizi bulmak için sitenin gezinme veya arama aracını kullanmayı deneyebilirsiniz.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'NBA League Pass hesabınız, izin verilen maksimum yayın akışı sayısına ulaştı. Bu cihazda izlemeye devam etmek için \'Devam Et\' düğmesine dokunun.',
	modal_pcm_custom: 'Devam et',
	modal_pcm_close: 'İptal',
	modal_adobe_concurrency_header_title: 'Video Bağlantısı Kesildi',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Yayınınız kapatıldı. Bunun sebebi maksimum aynı anda yayın sayısına ulaşılması, ağ kaybı veya teknik bir hata olabilir. Lütfen tekrar oturum açın ve devam etmek için bir kanal seçin.',
	modal_adobe_concurrency_close: 'Tamamlandı',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Bu video cihazınızda oynatılamaz. Daha fazla yardım için <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>BURAYA</a> tıklayın.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'Tamam',
	freesample_notice_time: 'Kalan süre',
	freesample_notice_title: '{0} Dakikalık NBA Pass Erişiminin Tadını Çıkar',
	freesample_notice_desc: '{0} dakikan sona erdiğinde içeriğe erişmeye devam etmek için tam League Pass paketine abone ol.',
	freesample_notice_subscribe_button: 'Abone ol',
	freesample_notice_cancel_button: 'İstediğin Zaman İptal Et',
	freesample_popup_title: 'ERİŞİMİN SONA ERDİ',
	freesample_popup_subtitle: 'Süper NBA içeriklerini daha fazla izlemek için League Pass\'e Abone ol.',
	freesample_popup_link: 'DAHA FAZLA BİLGİ EDİNİN!',
	freesample_popup_get_minutes_button: '{0}  DAKİKA KAZAN',
	reg_required_desc: 'Bu içeriği görüntülemek için oturum açmanız gerekiyor',
	favorite_teams_title: 'Favori Takımlar',
	bookmarked_title: 'Kaydedildi',
	watch_history_title: 'İzlemeye Devam Edin',
	game_schedule_title: 'Maç Programı',
	recommended_title: 'Tavsiye edilen',
	season_text: 'Sezon',
	section_tv_provider_title: 'TV Sağlayıcım',
	section_tv_provider_desc: 'TV sağlayıcınız üzerinden canlı maçlara ve yayınlara erişin.',
	section_tv_provider_faq: 'TV Sağlayıcı SSS',
	section_tv_provider_sign_out: 'Oturumu Kapat',
	header_menu_account_my_account: 'Hesabım',
	header_menu_account_manage_account: 'Hesabı Yönet',
	header_menu_account_favorite_teams: 'Favori Takımlar',
	header_menu_account_favorite_players: 'Favori Oyuncular',
	header_menu_account_viewing_history: 'Görüntüleme Geçmişi',
};
